// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GMoo","label":"styles_label__KeB_p"};